﻿import { UTL } from "../util/classes";
//panel_element.style.gap = "0.8em";
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
// כחול נקי (כמו ב-iOS/Android)

//console.log("AUX LOADED yes yes yes yes yes");

export class PopupPlusStyleRecord {
    //----------------------------------------
    // מחלקה הזאת אמורה לשרת את שלושת המחלקות
    // (1) AlertPlus
    // (2) ConfirmPlus
    // (3) PromptPlus
    //----------------------------------------
    public debug: boolean = false;
    //public caption_exist: boolean = false;
    public lang: string = "en";
    public direction: string = "ltr";
    public display_progress_milliseconds: boolean = false;
    //--------------------------------------------------------------------------------------------------------
    public base_fontSize: string = "20px"; // זה אמור לקבוע את כל הגדלים של החלון
    //--------------------------------------------------------------------------------------------------------
    public overlay_BackgroundColor: string = "rgba(0, 0, 0, 0.7)";
    //--------------------------------------------------------------------------------------------------------
    // popup אחד. זהו צבע הרקע הכללי של ה element שייך ליותר מאשר general_BackgroundColor להזכירך המונח
    //                                          popup_element,text_element,panel_element אמור להשפיע על
    public general_BackgroundColor: string = "white";
    //--------------------------------------------------------------------------------------------------------
    //public caption_element_fontSize: string = "20px"; // if exist
    public caption_element_color: string = "black";
    public caption_element_BackgroundColor: string = "lightblue";
    public caption_font_width: string = "700";
    //--------------------------------------------------------------------------------------------------------
    public text_element_color: string = "black";
    public text_font_width: string = "400";
    //--------------------------------------------------------------------------------------------------------
    public panel_element_BackgroundColor: string = "cyan"; // חדש
    //--------------------------------------------------------------------------------------------------------
    public prompt_input_element_color: string = "black";
    //--------------------------------------------------------------------------------------------------------
    public button_elements_BackgroundColor: string = "#ffffff";
    public button_elements_color: string = "black";

    public lang_is_english() {
        if (this.lang == "en" || this.lang == "eng") {
            return true;
        }
        else return false;
    }

    public lang_is_hebrew() {
        if (this.lang == "he" || this.lang == "heb") {
            return true;
        }
        else return false;
    }

    public lang_is_russian() {
        if (this.lang == "ru" || this.lang == "rus") {
            return true;
        }
        else return false;
    }


    private trans_size_from_string_to_number(p_size_str: string): number {
        // כאן בעתיד אפשר יהיה להוסיף בדיקות
        const parsed = parseInt(p_size_str);
        return parsed;
    }

    private getSharedHorizontalPadding(): string {
        // הוסף פונקציה כזו כדי שכולם יתיישרו לפיה
        const fs = parseInt(this.base_fontSize);
        return Math.round(fs * 1.2) + "px"; // נניח 44-48 פיקסלים
    }

    public calculate_caption_element_fontSize(): string {
        const fs = this.trans_size_from_string_to_number(this.base_fontSize);
        const fontsize_str: string = Math.round(fs * 0.85) + "px";
        return fontsize_str;
    }

    public calculate_text_element_fontSize(): string {
        // זה אמור להיות זהה לבסיס
        // זה אמור להיות זהה לבסיס
        return this.base_fontSize;
    }

    public calculate_prompt_inuput_element_fontSize(): string {
        const fs = this.trans_size_from_string_to_number(this.base_fontSize);
        const fontsize_str: string = Math.round(fs * 1.2) + "px";
        return fontsize_str;
    }


    public calculate_button_elements_fontSize(): string {
        const fs = this.trans_size_from_string_to_number(this.base_fontSize);
        const fontsize_str: string = Math.round(fs * 0.8) + "px";
        return fontsize_str;
    }


    public calculate_popup_border_radius(): string {
        const text_fontSize = this.calculate_text_element_fontSize();
        const fs: number = parseInt(text_fontSize);
        return (fs * 0.5) + "px"; // למשל עבור 20px תקבל פינות מעוגלות של 10px
    }

    public calculate_caption_element_paddings(): string {
        const caption_element_fontSize = this.calculate_caption_element_fontSize();
        const fs: number = parseInt(caption_element_fontSize);
        //const fs: number = parseInt(this.caption_element_fontSize);

        // בכותרת אנחנו רוצים פחות padding למעלה/למטה מאשר בטקסט
        // כדי שהיא לא תתפוס חצי מהפופאפ
        const topBottom = Math.round(fs * 0.5) + "px";
        const leftRight = Math.round(fs * 1.1) + "px";

        return `${topBottom} ${leftRight}`;
    }


    public calculate_text_element_paddings(): string {
        const text_element_fontSize = this.calculate_text_element_fontSize();
        const fs: number = parseInt(text_element_fontSize);
        const topBottom = Math.round(fs * 0.8) + "px";
        const leftRight = Math.round(fs * 1.1) + "px";

        return `${topBottom} ${leftRight}`;
    }

    public calculate_button_elements_paddings(): string {
        const fs = this.trans_size_from_string_to_number(this.calculate_button_elements_fontSize());

        // יחס של 0.6 לגובה ו-1.5 לרוחב נותן כפתור אלגנטי
        const topBottom = Math.round(fs * 0.7) + "px"; // מעט יותר גבוה ל-20px
        const leftRight = Math.round(fs * 1.6) + "px"; // רחב מספיק ללחיצה נוחה

        return `${topBottom} ${leftRight}`;
    }

    public calculate_panel_gap(): string {
        const buttons_fontSize = this.calculate_button_elements_fontSize();
        const fs: number = parseInt(buttons_fontSize);
        return (fs * 0.8) + "px"; // רווח פרופורציונלי לגודל הכפתור
    }

    public calculate_panel_element_paddings(): string {
        const fs = parseInt(this.base_fontSize);
        // אנחנו רוצים ריווח נדיב למטה ומהצדדים
        const p = Math.round(fs * 0.6) + "px";// שינוי ידני שלי
        const result_str: string = `${p} ${p} ${p} ${p}`; // 0 למעלה כי הכותרת כבר שם
        return result_str;
    }

    public calculate_popup_gap(): string {
        const fs = parseInt(this.base_fontSize);
        return Math.round(fs * 0.5) + "px"; // עבור 20px נקבל רווח של 10px בין החלקים
    }

    /*
    public calculate_popup_width(): string {
        const fs = this.trans_size_from_string_to_number(this.base_fontSize);
        // החישוב מחזיר את הרוחב האידיאלי כפונקציה של גודל הפונט
        const calculatedWidth = fs * 18;

        // אנחנו מחזירים ביטוי CSS שמוודא שהחלון לא יחרוג מהמסך במובייל (90%)
        return `min(${calculatedWidth}px, 90%)`;
    } */
}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class PopupPlusAuxFunctions {
    public static apply_style_to_overlay_element(overlay_element: HTMLDivElement, style_rec: PopupPlusStyleRecord): void {
        overlay_element.style.direction = style_rec.direction;
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.zIndex = "1000";
        if (true) {
            // style_rec כאן יש להכניס נתונים שבאים מה 
            overlay_element.style.backgroundColor = style_rec.overlay_BackgroundColor;
        }
    }

    public static apply_style_to_popup_element(popup_element: HTMLDivElement, style_rec: PopupPlusStyleRecord): void {
        // שלו child elements לא רואים אותו בכלל בגלל שהוא מכוסה לגמרי על כל ה pupup_element האלמנט  padding=0 להזירך שאם ה
        // שלו child elements לא רואים אותו בכלל בגלל שהוא מכוסה לגמרי על כל ה pupup_element האלמנט  padding=0 להזירך שאם ה
        popup_element.style.direction = style_rec.direction;
        popup_element.style.position = "absolute";
        popup_element.style.display = "flex";
        popup_element.style.flexDirection = "column";
        popup_element.style.justifyContent = "center";
        popup_element.style.alignItems = "stretch";
        popup_element.style.padding = "0px";
        if (true) {
            popup_element.style.maxWidth = "400px"; // example limit
        }
        //popup_element.style.width = style_rec.calculate_popup_width();
        //---------------------------------------------------------------------------------------
        // border-radius אשר יש לו popup היה חורג מה border-radius שאין להם children השורה הבאה חשובה מאוד כי היא בלעדיה ה
        // border-radius כלומר שבלעדיה השורה הזאת היינו מאבדים את
        popup_element.style.overflow = "hidden"; // חשוב מאד
        //---------------------------------------------------------------------------------------
        popup_element.style.border = /*"1px solid #e0e0e0"*/"none";
        popup_element.style.textAlign = "center";
        popup_element.style.textAlign = "center";
        popup_element.style.fontFamily = "system-ui, -apple-system, sans-serif";
        popup_element.style.gap = style_rec.calculate_popup_gap(); // הרווח בין כותרת/טקסט/כפתורים
        popup_element.style.borderRadius = style_rec.calculate_popup_border_radius();
        popup_element.style.backgroundColor = style_rec.general_BackgroundColor; // כחול נקי (כמו ב-iOS/Android)
        //popup_element.style.backgroundColor = "green"; // for debug
        if (style_rec.debug == true) {
            popup_element.style.padding = "20px"; // כדי לראות את הצבע
            popup_element.style.backgroundColor = "red";
        }
    }

    public static apply_style_to_caption_element(caption_element: HTMLDivElement, style_rec: PopupPlusStyleRecord): void {
        caption_element.style.direction = style_rec.direction;
        caption_element.style.backgroundColor = "blue";
        caption_element.style.color = "yellow";
        caption_element.style.fontWeight = style_rec.caption_font_width;
        //caption_element.style.alignSelf = "stretch";
        caption_element.style.margin = "0";
        caption_element.style.fontWeight = "700";
        caption_element.style.padding = style_rec.calculate_caption_element_paddings();
        caption_element.style.backgroundColor = style_rec.caption_element_BackgroundColor; // כחול נקי (כמו ב-iOS/Android)
        caption_element.style.color = style_rec.caption_element_color;           // טקסט לבן
        caption_element.style.fontSize = style_rec.calculate_caption_element_fontSize();
    }


    public static apply_style_to_text_element(text_element: HTMLDivElement, style_rec: PopupPlusStyleRecord): void {
        text_element.style.direction = style_rec.direction;
        text_element.style.backgroundColor = style_rec.general_BackgroundColor; // כחול נקי (כמו ב-iOS/Android)
        text_element.style.color = style_rec.text_element_color;           // טקסט לבן
        text_element.style.fontWeight = style_rec.text_font_width;           // טקסט לבן



        text_element.style.fontSize = style_rec.calculate_text_element_fontSize();
        text_element.style.lineHeight = "1.5"; // נותן אוויר בין השורות
        text_element.style.textAlign = "center"; // מרכוז הטקסט בתוך הבלוק
        text_element.style.padding = style_rec.calculate_text_element_paddings();
        text_element.style.margin = "0px";

        if (style_rec.debug == true) {
            text_element.style.backgroundColor = "pink";
        }
    }

    public static apply_style_to_prompt_input_element(prompt_input_element: HTMLInputElement, style_rec: PopupPlusStyleRecord): void {
        // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה
        // מסוג אחר input_element כי אולי בעתיד יהיו input_element ולא רק במילה prompt_input_element אנחנו משתמשים במילה

        prompt_input_element.style.display = "block";
        prompt_input_element.style.width = "80%";
        prompt_input_element.style.marginLeft = "auto";
        prompt_input_element.style.marginRight = "auto";
        prompt_input_element.type = "text";

        prompt_input_element.style.backgroundColor = style_rec.general_BackgroundColor; // כחול נקי (כמו ב-iOS/Android)
        prompt_input_element.style.color = style_rec.prompt_input_element_color;
        prompt_input_element.style.fontSize = style_rec.calculate_prompt_inuput_element_fontSize();
        prompt_input_element.style.lineHeight = "1.5"; // נותן אוויר בין השורות
        prompt_input_element.style.width = "80%";
        prompt_input_element.style.border = "3px solid #4A90E2";
        prompt_input_element.style.borderRadius = "8px";
        prompt_input_element.style.direction = style_rec.direction;
        prompt_input_element.style.marginBottom = "12px"; // להרחיק אותו מהכפתורים
        //input_element.style.inputAlign = "center"; // מרכוז הטקסט בתוך הבלוק
        //input_element.style.padding = style_rec.calculate_input_element_paddings();
        //input_element.style.margin = "auto";

        if (style_rec.debug == true) {
            prompt_input_element.style.backgroundColor = "pink";
        }
        prompt_input_element.style.backgroundColor = "pink";
    }

    public static apply_style_to_panel_element(panel_element: HTMLDivElement, style_rec: PopupPlusStyleRecord): void {
        panel_element.style.backgroundColor = "orange";
        //panel_element.style.alignSelf = "stretch";
        panel_element.style.justifyContent = "space-around";
        panel_element.style.display = "flex";
        panel_element.style.margin = "0";
        panel_element.style.flexDirection = "row";
        panel_element.style.alignItems = "center"; 

        //panel_element.style.padding = "5px";
        panel_element.style.padding = style_rec.calculate_panel_element_paddings(); // נותן אוויר לכפתורים
        panel_element.style.gap = style_rec.calculate_panel_gap(); // הרווח בין הכפתורים לבין עצמם

        // יהיה צבע משלו panel החל מתאריך 19.4.26 אנחנו חושבים שיהיה יותר יפה אם ל
        panel_element.style.backgroundColor = style_rec.panel_element_BackgroundColor;
    }

    public static apply_style_to_general_button_element(button_element: HTMLButtonElement, style_rec: PopupPlusStyleRecord): void {
        // פונקציה זאת אמורה להיות כללית לתכונות של כל הכפתורים
        const fs = parseInt(style_rec.base_fontSize);
        button_element.style.margin = "0px";
        //button_element.innerText = "close";
        //button_element.style.padding = "0.6em 1.5em";      // שטח לחיצה נוח לאצבע
        button_element.style.padding = style_rec.calculate_button_elements_paddings();

        //button_element.style.minWidth = "120px";         // רוחב מינימלי לכפתור יציב
        button_element.style.margin = "0px";
        button_element.style.border = "none";
        button_element.style.borderRadius = "15px";
        //button_element.style.fontSize = "16px";
        button_element.style.fontWeight = "600";
        button_element.style.fontFamily = "sans-serif";
        button_element.style.cursor = "pointer";
        button_element.style.marginBottom = "0px";
        button_element.style.minWidth = (fs * 6) + "px"; // עבור 20px זה ייתן 120px, עבור 26px זה יגדל ל-156px
        button_element.style.backgroundColor = style_rec.button_elements_BackgroundColor; // כחול נקי (כמו ב-iOS/Android)
        button_element.style.color = style_rec.button_elements_color;           // טקסט לבן
        button_element.style.fontSize = style_rec.calculate_button_elements_fontSize();



        //---------------------------------------
        // עבור כפתור שיש לו פוקוס !!אינו אמין!! ולכן אנחנו מציירים בנפרד outline שמצייר את ה HTML אמור שהמנגנון ב gemini שים לב ש
        // עבור כפתור שיש לו פוקוס !!אינו אמין!! ולכן אנחנו מציירים בנפרד outline שמצייר את ה HTML אמור שהמנגנון ב gemini שים לב ש
        // עבור כפתור שיש לו פוקוס !!אינו אמין!! ולכן אנחנו מציירים בנפרד outline שמצייר את ה HTML אמור שהמנגנון ב gemini שים לב ש 
        button_element.onfocus = () => {
            // זה ה"Refresh" האמיתי שלך - שינוי סטייל בזמן אמת
            button_element.style.outline = "3px solid #2196F3";
            button_element.style.outline = "3px solid black";
            button_element.style.outlineOffset = "2px";
        };

        button_element.onblur = () => {
            button_element.style.outline = "none";
        };
        //---------------------------------------
    }


    public static apply_style_to_ok_button_element(ok_button_element: HTMLButtonElement, style_rec: PopupPlusStyleRecord): void {
        PopupPlusAuxFunctions.apply_style_to_general_button_element(ok_button_element, style_rec);
        if (style_rec.lang_is_english() == true) {
            ok_button_element.innerText = "ok";
        }
        if (style_rec.lang_is_hebrew() == true) {
            ok_button_element.innerText = "אישור";
        }
        if (style_rec.lang_is_russian() == true) {
            ok_button_element.innerText = "ok"; // כמו באנגלית
        }
        //-------------------------------------------------------------------
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        //-------------------------------------------------------------------
    }

    public static apply_style_to_cancel_button_element(cancel_button_element: HTMLButtonElement, style_rec: PopupPlusStyleRecord): void {
        PopupPlusAuxFunctions.apply_style_to_general_button_element(cancel_button_element, style_rec);
        cancel_button_element.innerText = "cancel";
        if (style_rec.lang_is_english() == true) {
            cancel_button_element.innerText = "cancel";
        }
        if (style_rec.lang_is_hebrew() == true) {
            cancel_button_element.innerText = "ביטול";
        }
        if (style_rec.lang_is_russian() == true) {
            cancel_button_element.innerText = "Отмена"; // כמו באנגלית
        }


        //-------------------------------------------------------------------
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        //-------------------------------------------------------------------
    }

    public static apply_style_to_close_button_element(close_button_element: HTMLButtonElement, style_rec: PopupPlusStyleRecord): void {
        PopupPlusAuxFunctions.apply_style_to_general_button_element(close_button_element, style_rec);
        close_button_element.innerText = "close";
        if (style_rec.lang_is_english() == true) {
            close_button_element.innerText = "close";
        }
        if (style_rec.lang_is_hebrew() == true) {
            close_button_element.innerText = "סגור";
        }
        if (style_rec.lang_is_russian() == true) {
            close_button_element.innerText = "Закрыть"; // כמו באנגלית
        }
        //-------------------------------------------------------------------
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        // אם אנחנו רוצים לתת צבע נפרד לכל כפתור כנראה שזה המקום שיש לבצע זאת
        //-------------------------------------------------------------------
    }

    /*
    public static create_alert_default_style(): PopupPlusStyleRecord {
        const var_style_rec: PopupPlusStyleRecord = new PopupPlusStyleRecord();
        var_style_rec.debug = true;
        //var_style_rec.buttonTextColor = "black";
        // default כאן יש להוסיף ערכי
        // default כאן יש להוסיף ערכי
        // default כאן יש להוסיף ערכי 
        return var_style_rec;
    }
    */


    public static keydown_event_should_preventDefault(event: KeyboardEvent): boolean {
        if (event.key === 'Escape') return true;
        if (event.key === 'ArrowUp') return true;
        if (event.key === 'ArrowDown') return true;
        if (event.key === 'ArrowLeft') return true;
        if (event.key === 'ArrowRight') return true;
        if (event.key === 'Tab') return true;
        //------------------------------------
        return false;
    }


    public static create_rec_style_v1(p_direction: string = "ltr", p_base_fontSize: string = "30px", p_debug: boolean = false): PopupPlusStyleRecord {
        //alert(`p_direction=${p_direction}`);
        //debugger;
        if (typeof p_direction !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        if (typeof p_base_fontSize !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        const var_style_rec: PopupPlusStyleRecord = new PopupPlusStyleRecord();
        //alert(`p_direction=${p_direction}`);
        //debugger;
        var_style_rec.direction = p_direction;
        var_style_rec.base_fontSize = p_base_fontSize;
        var_style_rec.debug = p_debug;
        var_style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        //var_style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.1)";
        var_style_rec.general_BackgroundColor = "#FFFFFF";
        var_style_rec.caption_element_BackgroundColor = "#E3F2FD"; // תכלת בהיר מאוד לרקע הכותרת
        var_style_rec.caption_element_color = "#1565C0"; // כחול כהה לטקסט הכותרת
        var_style_rec.text_element_color = "#333333";
        var_style_rec.button_elements_BackgroundColor = "#2196F3";
        var_style_rec.button_elements_color = "#FFFFFF";
        return var_style_rec;
    }


    public static create_rec_style_v2(p_direction: string = "ltr", p_base_fontSize: string = "30px", p_debug: boolean = false): PopupPlusStyleRecord {
        if (typeof p_direction !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        if (typeof p_base_fontSize !== "string") {
            alert("Error: p_direction must be a string");
            return;
        }
        const var_style_rec: PopupPlusStyleRecord = new PopupPlusStyleRecord();
        var_style_rec.direction = p_direction;
        var_style_rec.base_fontSize = p_base_fontSize;
        var_style_rec.debug = p_debug;
        var_style_rec.overlay_BackgroundColor = "rgba(0, 0, 0, 0.5)";
        var_style_rec.general_BackgroundColor = "#FFF9C4";
        var_style_rec.caption_element_BackgroundColor = "#81D4FA";
        var_style_rec.caption_element_color = "#263238";
        var_style_rec.text_element_color = "#37474F";
        var_style_rec.button_elements_BackgroundColor = "#FFFFFF";
        var_style_rec.button_elements_color = "#263238";
        return var_style_rec;
    }










}
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//>>



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


